import React, { useState, useEffect, useCallback } from 'react';
import Select from 'react-select'
import Popup from 'reactjs-popup';
import { AgGridReact } from 'ag-grid-react';
import { UserService } from './../../service/user.service'
import { ApplicationService } from './../../service/application.service'
import Alert from '../common/Alert';
import Confirmation from '../common/Confirmation';

import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const ApprovalDelegation = (params) => {
    const [users, setUsers] = useState([]);
    const [approvers, setApprovers] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);    

    const [adId, setAdId] = useState(0);
    const [approver, setApprover] = useState({});
    const [assignTo, setAssignTo] = useState({});
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

    const [message, setMessage] = useState([]);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');

    const userService = new UserService();
    const applicationService = new ApplicationService();

    useEffect(() => {
        const fetchData = async () => {
            const resUser = await userService.getUsers();
            let dataUser = resUser.data.map(function (a) {
                return { value: a.id, label: (a.firstName + " " + a.lastName) };
            });
            setUsers(dataUser);

            const resApprover = await applicationService.getallapprovers();
            let dataApprover = resApprover.data.map(function (a) {
                return { value: a.id, label: (a.firstName + " " + a.lastName) };
            });
            setApprovers(dataApprover);

            const rsDetails = await applicationService.getApproverDelegationDetails();
            setRowData(rsDetails.data);
        }

        fetchData()
            .catch(console.error);
    }, []);


    useEffect(() => {
        if (loading === true) {
            const fetchDataforGrid = async () => {
                const rsDetails = await applicationService.getApproverDelegationDetails();
                setRowData(rsDetails.data);
                setLoading(false);
            }

            fetchDataforGrid()
                .catch(console.error);
        }
    }, [loading]);


    const onSuccess = async () => {
        if (checkValidation() === true) {
            console.log("I am going to save it!");
            let appDelegation = {
                id: adId,
                approverId: approver.value,
                delegateId: assignTo.value,
                startDate: startDate,
                endDate: endDate
            }

            let saveResult = await applicationService.saveApproverDelegation(appDelegation);
            if (saveResult.status === 200 && saveResult.data.isSuccess === true) {
                setAlertMessage(saveResult.data.message);
                alertOn();

                if (saveResult.data !== undefined && saveResult.data.isSuccess === true) {
                    setLoading(true);
                    clearIt();
                }
            }
            else {
                setAlertMessage(saveResult.data.message);
                alertOn();
            }
        }
    }

    const alertOff = () => {
        setIsAlert(false);
        params.onClose();
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    const removeMessage = (id) => {
        if (message.length > 0) {
            let newMessage = message.filter((m) => {
                return (m.id !== id);
            });
            setMessage(newMessage);
        }
    };

    const checkValidation = () => {
        let result = true;
        let newMessage = [];

        if (!approver || approver.value === 0 || approver.value === undefined) {
            newMessage.push({ id: 1, text: "Approver is required for this setup" });
            result = false;
        }

        if (!assignTo || assignTo.value === 0 || assignTo.value === undefined) {
            newMessage.push({ id: 2, text: "Delegation is required for this setup" });
            result = false;
        }

        if (!startDate) {
            newMessage.push({ id: 3, text: "Start date is required for is required" });
            result = false;
        }

        if (!endDate) {
            newMessage.push({ id: 4, text: "End date is required for  is required" });
            result = false;
        }

        setMessage(newMessage);
        return result;
    };

    const clearIt = () => {
        setAdId(0);
        setApprover({});
        setAssignTo({});
        setStartDate(new Date().toISOString().split('T')[0]);
        setEndDate(new Date().toISOString().split('T')[0]);
    };

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;;
        }
    }

    const editCellRenderer = (params) => {
        return <i className="fa fa-edit"></i>;
    };

    const deleteCellRenderer = (params) => {
        return <Popup trigger={<i style={{ color: "#970000" }} className="fa fa-trash"></i>} nested modal>{close => (<Confirmation message={"Are you sure, you want to delete this Approval delegation setup?"} data={params.data} onSuccess={deleteSetup} onClose={() => { close(); }}></Confirmation>)}</Popup>;        
    }

    const columnDefs = [
        { headerName: 'Approver', field: 'approverEmail', filter: true, width: 200, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Delegation', field: 'delegateEmail', width: 200, filter: false, cellRenderer: p => gridCellRenderer(p), resizable: false },
        { headerName: 'Start Date', field: 'startDate', width: 115, filter: false, cellRenderer: p => gridCellRenderer(p), resizable: false },
        { headerName: 'End Date', field: 'endDate', width: 115, filter: false, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: '', colId: 'edit-button', field: '', width: 30, sortable: false, cellRenderer: p => editCellRenderer(p), resizable: false },
        { headerName: '', colId: 'delete-button', field: '', width: 30, sortable: false, cellRenderer: p => deleteCellRenderer(p), resizable: false }
    ];

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25
    }

    const cellClickedListener = useCallback(event => {
        if (event.colDef.colId === 'edit-button') {
            setAdId(event.data.id)
            setApprover({ value: event.data.approver.id, label: (event.data.approver.firstName + " " + event.data.approver.lastName) });
            setAssignTo({ value: event.data.delegation.id, label: (event.data.delegation.firstName + " " + event.data.delegation.lastName) });

            const stDate = new Date(event.data.startDate);
            const enDate = new Date(event.data.endDate);

            setStartDate(stDate.toISOString().split('T')[0]);
            setEndDate(enDate.toISOString().split('T')[0]);
        }
    }, []);

    const deleteSetup = async (apDelegation) => {
        const curDate = new Date();
        const strDate = new Date(apDelegation.startDate);

        const totalDays = getDayDifference(strDate, curDate);
        if (totalDays <= 0) {
            setAlertMessage("This Approval delegation setus is back-dated or started today, You cannot delete this setup");
            alertOn();
        }
        else {
            var delResult = await applicationService.deleteApprovalDelegation(apDelegation.id);
            if (delResult.data) {
                setAlertMessage(delResult.data.message);
                setLoading(true);
                alertOn();
            };
        }
    };

    const getDayDifference = (date1, date2) => {
        const timeDiff = (date1.getTime() - date2.getTime());
        const diffInDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return diffInDays;
    };

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card centerDiv" style={{ width: "750px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> Approval Delegation
                </h5>
                <div className="card-body">
                    <div>
                        {(message.length > 0) ?
                            <ul>
                                {message.map(m =>
                                    <li style={{ color: "red" }} key={m.id}>{m.text}</li>
                                )}
                            </ul>
                            : ""}
                    </div>

                    <div className="ag-theme-alpine">
                        <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                            <div>
                                <label>Approver</label>
                                <Select options={users} id="approver" value={approver} onChange={(e) => { setApprover(e); removeMessage(1) } } />
                            </div>

                            <div className="row" style={{ marginTop: "20px" }}>
                                <div className="col-md-6">
                                    <label>Start Date</label>
                                    <input className="form-control" type="date" value={startDate} onChange={(e) => { setStartDate(e.target.value); removeMessage(3) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>End Date</label>
                                    <input className="form-control" type="date" value={endDate} onChange={(e) => { setEndDate(e.target.value); removeMessage(4) }} />
                                </div>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                <label>Select Delegation</label>
                                <Select options={approvers} id="selectDelegation" value={assignTo} onChange={(e) => { setAssignTo(e); removeMessage(2) }} />
                            </div>

                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                                <button onClick={onSuccess} className="btn btn-secondary">Save</button>
                                <button onClick={clearIt} style={{ marginLeft: "5px" }} className="btn btn-secondary">Clear</button>
                            </div>

                            <div style={{ marginTop: "30px", height: "250px" }}>
                                <AgGridReact
                                    rowData={rowData}
                                    onCellClicked={cellClickedListener}
                                    gridOptions={gridOptions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ApprovalDelegation;